<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý serial number</div>
      </div>
      <div class="card card-w-title">
        <div class="list-data">
          <div class="p-grid">
            <div class="p-col-6" v-if="$myConstants.checkRoleGroup('serial_number', 'download')" >
              <div class="import-data-custom download-data-custom">
                <button class="download-file-custom" @click="exportDataExcel" >
                  <i class="pi pi-download"></i>Xuất dữ liệu
                </button>
                <span >(Danh serial number được tải về theo điều kiện lọc đã nhập)</span>
              </div>
            </div>
          </div>
          <div class="list-title">
            <span class="p-m-0">Danh sách serial number</span>
          </div>
          <BaseCommon v-if="dataModel && checkVisible('serial_number', 'list')"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :globalFilterFields="globalFilterFields"
            @filter="filterData"
            :actions="getRowActions()"
            v-on:action-click="onActionClicked"
            @callback="callback"
            @clearFilter="cancelFilter"
            @filterExport="filterExport"
          ></BaseCommon>
        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left"><span style="font-weight: 700">Danh sách serial number</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu <span style="font-weight: 700;">Danh sách serial number</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
//import BaseCommon from '../common'
import BaseCommon from './core_list';
import moment from "moment";
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      globalFilterFields: [],
      listDataExport:[],
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      showConfirmDialog:false,
      userID : null,
      data_filter_export:null
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('serial_number', 'list')) {
          await this.initParams();
        }
      }, 1000);
    },
    callback(col, payload) {
      if (col.name == 'productionOrder') {
        this.$router.push({path: `/admin/serial-number/view/`+ payload.production_order.id});
      }
    },
    async initParams() {
      //this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      //this.$store.commit('setLoading', true);

      if(this.$route.params != undefined && this.$route.params != null && this.$route.params.model != undefined && this.$route.params.model != '') {
        this.filters['model_code'] = this.$route.params.model;
      }
      this.modelName = 'product_serial_number';
      /*var whereKey = {
        status: {'_in': [1] },
        production_status: {'_in': [1]}
      }*/
      //ẩn get serial theo user tạo || show ra fulllist
     /* if (this.$store.getters.fullname.user_type == 2) {
          whereKey = Object.assign(whereKey,  {production_order: { author_id: {'_eq': this.$store.getters.fullname.id } } }) 
      }*/
      /*var variables = {
        where_key: whereKey,
        orderBy: {
          modified_date: 'desc_nulls_last',
          created_date: 'desc_nulls_last',
          id: 'desc'
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];*/
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData([]);
      this.listDataExport = [];
      this.listData = [];
      this.componentKey++;
      //this.$store.commit('setLoading', false);
    },
    onActionClicked(payload) {
     var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          }
        break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // actions.header = { name: 'add', label: 'Tạo mới', path: `admin/product-${this.modelName}/add`};
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if(that.$myConstants.checkRoleGroup('serial_number', 'view_serial')) {
          buttons.view = {name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/serial-number/view-detail/`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
      // this.componentKey++;
      this.listDataExport = this.listData;
    },
    changeInput(event, col) {
      this.filters[col] = event.value;
      this.componentKey++;
    },
    async  exportDataExcel(){
      if (this.data_filter_export.is_data == 0){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tồn tại dữ liệu xuất',
          life: 3000
        });
        return false;
      }
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
        try {
          var dataResponse = await this.$coreService.callApiPost('/export_excel/list_serial',{data_filter_export:this.data_filter_export,user_id : this.userID},{})
          var key_s3 = dataResponse.data.data.key_s3;
          var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
          var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url;
          var file_excel = 'BC_DanhSachSerialNumber_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'.xlsx';
          link.setAttribute('download', file_excel)
          document.body.appendChild(link)
          link.click()
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_success';

      } catch (err) {
          console.log("err:",err);
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_err';
        }
      this.$store.commit('setLoading', false);
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    async filterData(payload){
      this.listDataExport = payload.filteredValue;
    },
	async filterExport(e){
       //console.log("EEE",e)
      this.data_filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000; }
  }
  span{color: #199ED8; padding-left: 5px;}
}
.import-data .download-file {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>